"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SiteLinks = _interopRequireDefault(require("./SiteLinks"));
var _SupportLinks = _interopRequireDefault(require("./SupportLinks"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

/**
 * Top level node of link groups.
 */
class Drawer extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      windowHeight: 0,
      windowWidth: 0,
      windowZIndex: -10
    };
  }
  componentDidMount() {
    this.setState({
      windowHeight: this.drawerContainer.offsetHeight + 'px',
      windowWidth: this.drawerContainer.offsetWidth + 'px'
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm-12 col-lg-6 col-md-7 header-drawer",
      onClick: this.props.handleBubble,
      style: this.props.isMobile ? {
        overflowY: 'scroll',
        overflowX: 'hidden',
        right: this.props.open ? this.props.isMobile ? '0' : this.state.windowWidth : -280,
        transition: this.props.open ? 'all .3s ease-in-out' : '0',
        zIndex: -10,
        position: 'fixed',
        background: '#000',
        width: this.props.open ? this.props.isMobile ? '60%' : this.state.windowWidth : 0,
        height: '100%',
        padding: '0'
      } : {
        padding: '0',
        width: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "drawer-container",
      style: {
        padding: this.props.isMobile ? '70px 0 0 0' : '0'
      },
      ref: container => {
        this.drawerContainer = container;
      }
    }, /*#__PURE__*/_react.default.createElement(_SiteLinks.default, {
      links: this.props.siteLinks,
      isMobile: this.props.isMobile
    }), /*#__PURE__*/_react.default.createElement(_SupportLinks.default, {
      links: this.props.supportLinks,
      isMobile: this.props.isMobile,
      mobileAppText: this.props.mobileAppText
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "clearfix"
    })));
  }
}
exports.default = Drawer;
Drawer.propTypes = {
  siteLinks: _propTypes.default.array,
  supportLinks: _propTypes.default.array,
  socialLinks: _propTypes.default.array,
  open: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  handleBubble: _propTypes.default.func,
  mobileAppText: _propTypes.default.object
};
Drawer.defaultProps = {
  siteLinks: [],
  supportLinks: [],
  open: false
};